import { post } from './api';

export const upload = body => post('/upload', body);

export const uploadFromKey = body =>
  post('/upload/cropFromKey', JSON.stringify(body), {
    'Content-Type': 'application/json',
  });



// WEBPACK FOOTER //
// ./src/services/uploadApi.js